export default __webpack_public_path__ + "static/media/gelato-adds.b17ac5b5.jpg";